/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TimedStructureControl } from "./TimedStructureControl";
import {
  TimedStructureControlFromJSON,
  TimedStructureControlFromJSONTyped,
  TimedStructureControlToJSON,
  TimedStructureControlToJSONTyped,
} from "./TimedStructureControl";

/**
 *
 * @export
 * @interface PaginatedTimedStructureControlList
 */
export interface PaginatedTimedStructureControlList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TimedStructureControl>;
}

/**
 * Check if a given object implements the PaginatedTimedStructureControlList interface.
 */
export function instanceOfPaginatedTimedStructureControlList(
  value: object
): value is PaginatedTimedStructureControlList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTimedStructureControlListFromJSON(
  json: any
): PaginatedTimedStructureControlList {
  return PaginatedTimedStructureControlListFromJSONTyped(json, false);
}

export function PaginatedTimedStructureControlListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTimedStructureControlList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TimedStructureControlFromJSON),
  };
}

export function PaginatedTimedStructureControlListToJSON(
  json: any
): PaginatedTimedStructureControlList {
  return PaginatedTimedStructureControlListToJSONTyped(json, false);
}

export function PaginatedTimedStructureControlListToJSONTyped(
  value?: PaginatedTimedStructureControlList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TimedStructureControlToJSON),
  };
}
